import React from "react";
import { Card } from "@mantine/core";
import { useGetMerchantWalletBalance } from "../../../../hooks/queries/useMerchantQueries";
import FetchFeedback from "../../../ui/CustomFetchFeedback/CustomFetchFeedback";
import StatCard from "./statCard";
import StatCardSkeleton from "./StatCardSkeleton";
import { formatKES } from "../../../../utils/transactionutils";

export default function BalanceStatCard() {
  const { data, isLoading, isError, refetch } = useGetMerchantWalletBalance();

  if (isLoading) {
    return <StatCardSkeleton className="bg-primary-600" />;
  }

  if (isError) {
    return (
      <Card className="bg-primary-600 min-h-[100px] sm:min-h-[130px] flex items-center justify-center p-3 sm:p-6">
        <FetchFeedback
          message="Failed to load balance."
          onRetry={refetch}
          fullHeight={false}
          compact
        />
      </Card>
    );
  }

  return (
    <StatCard
      label="Current Balance"
      value={formatKES(data?.balance)}
      className="bg-primary-600"
      labelClassName="text-white-50 font-semibold"
      valueClassName="text-white-50"
    />
  );
}
